import type { JSX } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from '@/app/providers';
import { AppRouter } from '@/app/router';

/**
 * Root component (ADR-026: React Router, browser-history SPA). Stays
 * thin - routing lives in app/router.tsx, cross-cutting providers in
 * app/providers.tsx.
 */
export default function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </BrowserRouter>
  );
}
